import { createI18n } from 'vue-i18n'
import zhCN from './lang/zh-CN'
import enUS from './lang/en-US'
import store from '@/store'

// 修复点1：移除旧版Locale调用
// Locale.use() 已不再需要

// 修复点2：使用Vue 3推荐配置
const messages = {
  'zh_CN': zhCN,
  'en_US': enUS
}

const getLang = () => {
    let lang = localStorage.getItem('language')
    const env = store.state.common.env || {}
    if (env && env.currentLanguage) {
      lang = env.currentLanguage === 'en_US' ? 'en_US' : 'zh_CN'
    }

    if (!lang) {
      const navLang = navigator.language
      lang = navLang.includes('en') ? 'en_US' : 'zh_CN'
    }

    store.commit('common/setLang', lang)
    return lang
  }
// 修复点3：正确创建i18n实例
export const i18n = createI18n({
  locale: getLang(),
  messages,
  warnHtmlInMessage: 'off',
  globalInjection: true,
  fallbackLocale: 'zh_CN',
  legacy: false // 关键修改：禁用Vue2兼容模式
})
